import orderItem from '@/modules/user-info/components/order-item/index.vue'
import {mapGetters, mapActions} from "vuex";

export default {
    name: 'current-order',
    components: {
        orderItem
    },
    data() {
        return {
            hideProduct: true
        }
    },
    created() {
        this.orderStatus()
    },
    methods: {
        ...mapActions({
            orderStatus: 'order/ORDER_STATUS'
        })
    },
    computed: {
        ...mapGetters({
            getCurrentOrder: 'order/getCurrentOrder',
            getStatus: 'order/orderStatus'

        }),

    }
}
